<template>
  <div>
    <div class="page flex-col visitor">
      <div class="box_1 flex-col">
        <div class="box_2 flex-col">

          <div class="block_1 flex-col">
            <div class="group_1 flex-col"></div>
            <div class="group_4 flex-col">
              <img class="image_533" referrerpolicy="no-referrer" src="https://lanhu.oss-cn-beijing.aliyuncs.com/MasterDDSSlicePNG4191c8313c2099dd6cd517ffe370aff5.png" />
              <div class="text-group_1 flex-col justify-between">
                <span class="paragraph_1">{{langWord.invite}}</span>
                <div class="tips">
                  {{ this.type == 'vips' ? langWord.guestWord : langWord.personWord}}
                </div>
                <template v-if="lang == 'zh-CN'">
                  <span class="text_2">{{langWord.dearTip}}</span>
                  <span class="text_3" v-html="langWord.dearTip2"></span>
                  <span class="text-10">“{{forumName}}”</span>
                </template>
                <template v-else>
                  <span class="text_2">{{langWord.dearTip}}</span>
                  <span class="text_3">
                    {{langWord.dearTip2}}
                    <span class="text-10">“{{forumNameEn}}”</span>
                    {{langWord.dearTip3}}
                  </span>

                </template>
              </div>
            </div>
          </div>

          <div class="block_2 flex-row">
            <div class="text-group_3 flex-col">
              <span class="text_5">{{langWord.date}}</span>
              <span class="text_6">{{time}}</span>
              <span class="text_7">{{langWord.address}}</span>
              <span class="text_8">{{address}}</span>
            </div>
            <span class="text_9" v-html="langWord.scanCode"></span>

            <div class="image_534" v-if="lang == 'zh-CN'">
              <img class="image_534_1" referrerpolicy="no-referrer" :src="qrCodeUrl" />
            </div>

            <div class="image_535" v-else>
              <img class="image_535_1" referrerpolicy="no-referrer" :src="qrCodeUrl" />
            </div>

          </div>

        </div>
      </div>

    </div>
    <div id='DONE' v-if="complete"></div>

  </div>
</template>


<script>
import { GetQueryString, loadImageEnd } from '@/utils/utils'
import { getForumnInviteInfo } from '@/api/inviteApi.js'
export default {
  name: 'forumInvite',
  data() {
    return {
      token: '',
      appKey: 'WX_MINI_GDTE',
      eventKey: 'GDTE_2022',
      headerClientInfo: {},
      info: {},
      complete: false,
      index: 0,
      lang: '',
      type: '',
      forumName: '',
      forumNameEn: '',
      langWord: {},
      invite2023: {
        title: 'The 2nd Global<br /> Digital Trade Expo',
        title1: 'Digital Trade    Global Access',
        welcome: 'Welcome to GDTE～',
        date: 'Date',
        address: 'Venue',
        address1: 'Hangzhou International Expo <br /> Center',
        scanCode: 'Scan Code <br />Registration',
        downLoadTxt: 'Download Invitation',
        invite: 'INVITATION',
        guestWord: 'VIPs',
        personWord: 'Guests',
        dearTip: 'Dear sir/madam',
        dearTip2: 'We have the pleasure of inviting you to attend',
        dearTip3: 'during the second Global Digital Trade Expo 2023',
      },
      invite2023_zh: {
        title: '全球数字贸易<br />博览会',
        title1: '数字贸易&nbsp;商通全球',
        welcome: '邀请您参展～',
        date: '展会时间',
        address: '展会地点',
        address1: '杭州国际博览中心',
        scanCode: '扫码注册',
        downLoadTxt: '下载邀请函',
        invite: '邀请函',
        guestWord: '参会嘉宾',
        personWord: '参会观众',
        dearTip: '尊敬的女士/先生',
        dearTip2: '我们诚邀您参加<br />2023全球数字贸易博览会<br />期间举办',
      },
    }
  },
  created() {
    this.forumName = decodeURIComponent(GetQueryString('forumName'))
    this.forumNameEn = decodeURIComponent(GetQueryString('forumNameEn'))
    this.time = decodeURIComponent(GetQueryString('time'))
    this.type = decodeURIComponent(GetQueryString('type'))
    this.qrCodeUrl = decodeURIComponent(GetQueryString('qrCodeUrl'))
    this.lang = decodeURIComponent(GetQueryString('lang'))
    this.address = decodeURIComponent(GetQueryString('address'))
    if (this.lang == 'en-US') {
      this.langWord = this.invite2023
    } else {
      this.langWord = this.invite2023_zh
    }
    let allImg = ['https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/GDT/images/invate/2023.png']
    loadImageEnd(allImg, () => {
      console.log('图片加载完毕')
      this.complete = true
    })
  },
  methods: {
    dateFormat(fmt, date1, date2) {
      // date = new Date(date)

      let date = new Date(date1).toString().split(' ')
      let endDate = new Date(date2).toString().split(' ')

      var year = date[3] + '年'
      var month = new Date(date1).getMonth() + 1 + '月'
      var day = (date[2].indexOf('0') == 0 ? date[2].split('0')[1] : date[2]) + '日'
      var Hour = new Date(date1).getHours().toString() < 10 ? '0' + new Date(date1).getHours().toString() : new Date(date1).getHours().toString()
      var Minutes = new Date(date1).getMinutes().toString() < 10 ? '0' + new Date(date1).getMinutes().toString() : new Date(date1).getMinutes().toString()
      var endMonth = new Date(date2).getMonth() + 1 + '月'
      var endDay = (endDate[2].indexOf('0') == 0 ? endDate[2].split('0')[1] : endDate[2]) + '日'
      var endHour = new Date(date2).getHours().toString() < 10 ? '0' + new Date(date2).getHours().toString() : new Date(date2).getHours().toString()
      var endMinutes = new Date(date2).getMinutes().toString() < 10 ? '0' + new Date(date2).getMinutes().toString() : new Date(date2).getMinutes().toString()

      // 开始日期和结束日期同一天时
      if (date[1] == endDate[1] && date[2] == endDate[2] && date[3] == endDate[3]) {
        return year + '' + month + '' + day + '' + Hour + ':' + Minutes + '-' + endHour + ':' + endMinutes
      } else {
        return month + '' + day + '' + Hour + ':' + Minutes + ' - ' + endMonth + '' + endDay + ' ' + endHour + ':' + endMinutes
      }
    },
  },
}
</script>



<style lang="less" scoped>
.visitor {
  position: relative;
  width: 670px;
  height: 1190px;
  overflow: hidden;
  text-align: left;
  .box_1 {
    // background-color: rgba(21, 48, 151, 1);
    height: 1200px;
    width: 670px;
  }

  .box_2 {
    background: url('https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/GDT/mini/img/invite/inviteposter.png') center center/cover no-repeat;
    height: 1200px;
    width: 669px;
    position: relative;
  }

  .block_1 {
    position: relative;
    width: 2984px;
    height: 986px;
    margin: -17px 0 0 -131px;
  }

  .group_1 {
    position: absolute;
    left: 0;
    top: 0;
    width: 2984px;
    height: 986px;
  }

  .group_4 {
    position: absolute;
    left: 0;
    top: 0;
    width: 2984px;
    height: 986px;
  }

  .image_533 {
    width: 144px;
    height: 149px;
    margin: 55px 0 0 172px;
  }

  .box_3 {
    width: 166px;
    height: 58px;
    margin: 59px 0 0 177px;
  }

  .text-group_1 {
    width: 500px;
    height: 228px;
    margin: 15px 0 0 172px;
    flex-direction: column;
    display: flex;
    margin-top: 30px;
  }

  .image_544 {
    width: 185px;
    height: 65px;
    margin: 15px 0 0 182px;
  }

  .paragraph_1 {
    font-size: 110px;
    font-weight: 600;
    color: #ffffff;
    position: relative;
  }

  .tips {
    width: 164px;
    height: 54px;
    background: linear-gradient(133deg, #ffe8cb 0%, #48ff51 100%);
    border-radius: 10px 10px 10px 10px;
    font-size: 34px;
    font-weight: 600;
    color: #153097;
    text-align: center;
    line-height: 54px;
    position: relative;
    top: -20px;
  }

  .text_1 {
    font-size: 58px;
    font-weight: 400;
    color: #ffffff;
  }

  .box_4 {
    width: 448px;
    height: 120px;
    margin: 87px 0 0 175px;
    text-align: left;
  }

  .single-avatar_1 {
    width: 120px;
    height: 120px;
  }

  .text-group_2 {
    width: 312px;
    height: 85px;
    margin-top: 18px;
  }

  .text_2 {
    font-size: 34px;
    font-weight: 600;
    color: #ffffff;
    margin-top: 30px;
  }
  .text-10 {
    font-size: 34px;
    font-weight: 500;
    color: #91f582;
  }
  .text_3 {
    font-size: 28px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
    margin-top: 60px;
    margin-bottom: 25px;
  }

  .text_4 {
    width: 504px;
    height: 39px;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 28px;
    font-family: PingFang SC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 39px;
  }

  .text_5 {
    width: 112px;
    height: 41px;
    overflow-wrap: break-word;
    color: rgba(72, 249, 255, 1);
    font-size: 28px;
    font-family: Source Han Sans CN-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 41px;
  }

  .block_2 {
    position: absolute;
    left: 0;
    top: 969px;
    width: 669px;
    height: 232px;
  }

  .text-group_3 {
    width: 224px;
    height: 145px;
    margin: 7px 0 0 47px;
    position: relative;
    top: -56px;
  }

  .text_6 {
    width: 187px;
    height: 41px;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 28px;
    font-family: Source Han Sans CN-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 41px;
  }

  .text_7 {
    width: 112px;
    height: 41px;
    overflow-wrap: break-word;
    color: rgba(72, 249, 255, 1);
    font-size: 28px;
    font-family: Source Han Sans CN-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 41px;
    margin-top: 18px;
  }

  .text_8 {
    width: 460px;
    height: 41px;
    color: rgba(255, 255, 255, 1);
    font-size: 28px;
    font-family: Source Han Sans CN-Medium;
    font-weight: 500;
    text-align: left;
    line-height: 41px;
    margin-top: 4px;
    display: block;
  }

  .text_9 {
    width: 180px;
    height: 90px;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 20px;
    font-family: Source Han Sans CN-Regular;
    text-align: left;
    margin: 150px 84px 0 234px;
  }

  .image_534 {
    position: absolute;
    left: 465px;
    top: -23px;
    width: 160px;
    height: 160px;
    background: #fff;
    border-radius: 50%;
    .image_534_1 {
      width: 152px;
      height: 152px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      // border-radius: 50%;
    }
  }
  .image_535 {
    position: absolute;
    left: 465px;
    top: -23px;
    width: 160px;
    height: 160px;
    background: #fff;
    .image_535_1 {
      width: 152px;
      height: 152px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>